export const visibleStores = [
  {
    geo: {
      distance: 4.699660719820766,
      latitude: 40.63965,
      longitude: -89.5374,
    },
    website: 'https://www.altorfer.com/contact-us/',
    dealerName: 'ALTORFER INC.',
    address: {
      zipCode: '61611-4820',
      country: 'US',
      city: 'East Peoria',
      phone: '3096941234',
      state: 'Illinois',
      line3: '',
      line2: '',
      line1: '1 Capitol Dr',
      email: 'nkruzich@altorfer.com',
    },
    storeHours: [
      {
        index: 1,
        label: 'TUESDAY',
        value: '08:00 AM - 05:00 PM',
      },
      {
        index: 2,
        label: 'WEDNESDAY',
        value: '08:00 AM - 05:00 PM',
      },
      {
        index: 3,
        label: 'THURSDAY',
        value: '08:00 AM - 05:00 PM',
      },
      {
        index: 4,
        label: 'FRIDAY',
        value: '08:00 AM - 05:00 PM',
      },
      {
        index: 5,
        label: 'SATURDAY',
        value: '08:00 AM - 12:00 PM',
      },
      {
        index: 6,
        label: 'SUNDAY',
        value: 'Closed',
      },
      {
        index: 0,
        label: 'MONDAY',
        value: '08:00 AM - 05:00 PM',
      },
    ],
    name: 'East Peoria',
    storeLocationCode: '02',
    id: 18465,
    services: [
      'Machine',
      'Engine Services',
      'Power Systems',
      'Equipment Sales',
      'Equipment Service',
      'Parts Pick-up',
      'Parts Sales',
      'Technology Solutions',
    ],
    storeId: '20196',
  },
];
